import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Settimana } from "@/types/api";

export function useSettimana() {
  return useQuery({
    queryKey: ["settimana"],
    queryFn: () => apiFetch<Settimana>("/api/v1/settimana"),
    staleTime: 60_000,
  });
}
